module.exports = __webpack_public_path__ + "static/media/painting2.2eda4226.jpg";